import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-950 border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="text-2xl font-mark font-bold text-gradient-primary mb-4">
              NL
            </div>
            <p className="text-dark-300 text-sm font-sans leading-relaxed">
              Building intelligent solutions through AI, mobile development, and thoughtful design.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-dark-50 font-heading font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="/agents" className="text-dark-300 hover:text-white transition-colors duration-200 text-sm font-sans">
                  AI Agents
                </a>
              </li>
              <li>
                <a href="/apps" className="text-dark-300 hover:text-white transition-colors duration-200 text-sm font-sans">
                  Apps
                </a>
              </li>
              <li>
                <a href="/web" className="text-dark-300 hover:text-white transition-colors duration-200 text-sm font-sans">
                  Web
                </a>
              </li>
              <li>
                <a href="/contact" className="text-dark-300 hover:text-white transition-colors duration-200 text-sm font-sans">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-dark-50 font-heading font-semibold mb-4">Connect</h3>
            <div className="space-y-3">
              <div>
                <p className="text-dark-300 text-sm font-sans">Email</p>
                <a href="mailto:hello@nikolaslarson.com" className="text-primary-400 hover:text-primary-300 transition-colors duration-200 text-sm font-sans">
                  nlarson@middlebury.edu
                </a>
              </div>
              <div className="flex space-x-4 mt-4 flex-row justify-center">
                <a href="https://www.linkedin.com/in/nikolaslarson/" className="w-8 h-8 bg-dark-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-colors duration-200">
                  <svg className="w-4 h-4 text-dark-200 hover:text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </a>
                <a href="https://github.com/NLarson2504" className="w-8 h-8 bg-dark-800 rounded-lg flex items-center justify-center hover:bg-dark-700 transition-colors duration-200">
                  <svg className="w-4 h-4 text-dark-200 hover:text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center">
          <div className="text-dark-400 text-sm font-sans">
            © {currentYear} Nikolas Larson. All rights reserved.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#privacy" className="text-dark-400 hover:text-white transition-colors duration-200 text-sm font-sans">
              Privacy Policy
            </a>
            <a href="#terms" className="text-dark-400 hover:text-white transition-colors duration-200 text-sm font-sans">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;